export enum DecisionListFilterActionsEnum {
  DECISION_LIST_FILTER_SET_SWITCHER = 'DECISION_LIST_FILTER_SET_SWITCHER',
  DECISION_LIST_FILTER_SET_CURRENT = 'DECISION_LIST_FILTER_SET_CURRENT',
  DECISION_LIST_FILTER_SET_PLAN_NUM = 'DECISION_LIST_FILTER_SET_PLAN_NUM',
  DECISION_LIST_FILTER_GET_META = 'DECISION_LIST_FILTER_GET_META',
  DECISION_LIST_FILTER_SET_META = 'DECISION_LIST_FILTER_SET_META',
  DECISION_LIST_FILTER_GET_DATA = 'DECISION_LIST_FILTER_GET_DATA',
  DECISION_LIST_FILTER_SET_DATA = 'DECISION_LIST_FILTER_SET_DATA',
  DECISION_LIST_FILTER_CREATE = 'DECISION_LIST_FILTER_CREATE',
  DECISION_LIST_FILTER_UPDATE = 'DECISION_LIST_FILTER_UPDATE',
  DECISION_LIST_FILTER_REMOVE = 'DECISION_LIST_FILTER_REMOVE',
  DECISION_LIST_FILTER_INIT = 'DECISION_LIST_FILTER_INIT',
  DECISION_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS = 'DECISION_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS',
  DECISION_LIST_FILTER_SET_CURRENT_SUPERVISION_TYPES = 'DECISION_LIST_FILTER_SET_CURRENT_SUPERVISION_TYPES',
}
